import { useCallback, useState } from 'react';
import { A28, A28Input } from 'api/U002';
import { FetchError } from 'api/API';

type SendConsentFormResponse = {
  status: string;
  msgid: string;
};

type CreateGroupUserDoRequest = (param: {
  request: A28Input;
  onSuccess?: (response: SendConsentFormResponse) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useCreateGroupUser(): [CreateGroupUserDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const sendConsentForm = async (request: A28Input, cancellation: AbortSignal) => {
    const json = await A28(request, cancellation);
    return json;
  };

  const doRequest = useCallback<CreateGroupUserDoRequest>(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        setLoading(true);
        const result = await sendConsentForm(request, cancelSignal);
        onSuccess?.(result);
      } catch (err) {
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          onError?.(flooredError);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          onError?.(flooredError);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    },
    [sendConsentForm, setLoading, setError]
  );

  return [doRequest, loading, err];
}
